export default __webpack_public_path__ + "static/media/AxionSupportTool.2c553205.jpg";